export enum PositionsColumns {
  name = 'name',
  quantity = 'quantity',
  averagePrice = 'averagePrice',
  lastPrice = 'lastPrice',
  profit = 'profit',
  balance = 'balance'
}
